import { CoinTickersMapped } from "../../../../types/api-results/coin-tickers";
import { CurrencySymbol } from "../../../../types/currency";
import { buildExchangeUrl } from "../../../utils/build-url";
import { formatCurrency, formatPercent } from "../../../utils/format-number";

interface FormatCoinTickersInput {
  data: CoinTickersMapped[];
  totalVolume: number;
  usdExchangeRate?: number;
  currency: CurrencySymbol;
}

export const formatCoinTickers = ({
  data,
  totalVolume,
  usdExchangeRate,
  currency,
}: FormatCoinTickersInput) => {
  return data
    .map((row, index) => ({
      key: `${row.market.name}/${row.base.id}/${row.target}`,
      rank: index + 1,
      marketName: row.market.name,
      marketLogo: row.market.logo,
      marketUrl: buildExchangeUrl(row.market.slug),
      isDex: row.market.isDex,
      fromCoin: row.base,
      target: row.target,
      pairSymbols: `${row.base.symbol?.toUpperCase()}/${row.target.toUpperCase()}`,
      tradeUrl: row.tradeUrl,
      price: row.convertedLast?.usd
        ? formatCurrency({
            value: row.convertedLast.usd * (usdExchangeRate || 1),
            currency,
          })
        : undefined,
      volume: row.convertedVolume?.usd
        ? formatCurrency({
            value: row.convertedVolume.usd * (usdExchangeRate || 1),
            currency,
          })
        : undefined,
      volumePercent:
        row.convertedVolume?.usd && totalVolume
          ? formatPercent({
              value: (row.convertedVolume.usd / totalVolume) * 100,
            })
          : undefined,
    }))
    .filter((t) => t.fromCoin.name && t.fromCoin.symbol && t.fromCoin.image);
};
